import { Close, InfoOutlined } from "@mui/icons-material";
import { Dialog, DialogProps } from "@mui/material";
import { COLORS } from "utils/colors";
import { PREFER_NOT_TO_ANSWER_POPUP } from "utils/constants";

import { PreferNotToAnswerDialogProps } from "./interface";
import {
  ButtonsContainer,
  DialogCloseButton,
  DialogContentWrapper,
  HeadingText,
  IconBadge,
  PrimaryButton,
  SecondaryButton,
  SubheadingText,
} from "./styled.components";

const PreferNotToAnswerDialog = (props: PreferNotToAnswerDialogProps) => {
  const { show, dismiss, onChangeAnswerClick, onContinueClick } = props;

  const handleClose: DialogProps["onClose"] = (event: any, reason: any) => {
    if (reason && reason === "backdropClick") return;
    dismiss();
  };

  return (
    <Dialog open={show} onClose={handleClose}>
      <DialogContentWrapper>
        <DialogCloseButton onClick={dismiss}>
          <Close fontSize="small" />
        </DialogCloseButton>

        <IconBadge>
          <InfoOutlined
            sx={{ color: COLORS.BRAND_DEFAULT_COLOR, fontSize: "2rem" }}
          />
        </IconBadge>

        <HeadingText>{PREFER_NOT_TO_ANSWER_POPUP.HEADING}</HeadingText>
        <SubheadingText>
          {PREFER_NOT_TO_ANSWER_POPUP.DESCRIPTION}
        </SubheadingText>

        <ButtonsContainer>
          <SecondaryButton variant="outlined" onClick={onContinueClick}>
            {PREFER_NOT_TO_ANSWER_POPUP.CONTINUE_BUTTON_TEXT}
          </SecondaryButton>
          <PrimaryButton variant="contained" onClick={onChangeAnswerClick}>
            {PREFER_NOT_TO_ANSWER_POPUP.CHANGE_ANSWER_BUTTON_TEXT}
          </PrimaryButton>
        </ButtonsContainer>
      </DialogContentWrapper>
    </Dialog>
  );
};

export default PreferNotToAnswerDialog;
